import type { ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import { AppText } from "./AppText";
import {
  spacing,
  type,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

/** Card/section intro: title + optional supporting line. */
export function SectionHeader({
  title,
  description,
  action,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.wrap}>
      <View style={stylesheet.text}>
        <Text style={stylesheet.title}>{title}</Text>
        {description ? (
          typeof description === "string" ? (
            <AppText size="xs" tone="muted">
              {description}
            </AppText>
          ) : (
            description
          )
        ) : null}
      </View>
      {action ? <View>{action}</View> : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    wrap: {
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: spacing.m,
    },
    text: { flex: 1, minWidth: 0, gap: 3 },
    title: { ...type.heading, color: colors.heading },
  });
